import Resource from "./resource";
import request from "../utils/request";

/**
 *Handles uploading and processing of files
 */
class RecordResource extends Resource {
  constructor() {
    super("fileupload_pushreports");
  }
  getDataRecords() {
    return request({
      url: `/${this.uri}/data/data_records/`,
      method: "get",
    });
  }
  getData() {
    return request({
      // url: `/pusher/data/${id}/push/`,
      url: `/fileuploads/?application=DMI&size=1500`,
      method: "get",
    });
  }
}

export { RecordResource as default };
